const $inject = [];
const lbaCountrySelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaCountrySelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaCountrySelect.html')
  }
};

lbaCountrySelect.$inject = $inject;

export default lbaCountrySelect;



// WEBPACK FOOTER //
// ./src/components/lbaCountrySelect/lbaCountrySelectDir.js